export { getInitials } from "./stringUtils";
